<script>
export default {
  props: {
    value: Boolean,
    module: Object,
  },
  methods: {
    handlerInput(e) {
      this.$emit('input', e);
      this.module.badge = false;
      this.module.read();
    },
  },
};
</script>
<template>
  <v-menu
    :value="value"
    @input="handlerInput"
    left
    bottom
    offset-y
    :close-on-click="true"
    :disabled="!module.items.length"
    max-height="80vh"
    max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        title="Новости"
        :disabled="!module.items.length"
      >
        <v-badge
          :value="module.badge"
          color="red"
          overlap
          dot
        >
          <v-icon>mdi-newspaper-variant</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="item in module.items"
        :key="item.id"
        :href="item.link"
        target="_blank"
        link
      >
        <v-list-item-content>
          <v-list-item-title>{{item.date | date}}</v-list-item-title>
          <v-list-item-subtitle v-text="item.label"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
